"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextEllipsis = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_jss_1 = __importDefault(require("react-jss"));
const classnames_1 = __importDefault(require("classnames"));
const react_middle_ellipsis_1 = __importDefault(require("react-middle-ellipsis"));
const useMeasure_1 = __importDefault(require("../../utils/hooks/useMeasure"));
const textEllipsis_style_1 = __importDefault(require("./textEllipsis.style"));
const TextEllipsis = ({ classes, className = '', text = '', middleEllipsis = false }) => {
    const containerRef = react_1.useRef();
    const [measureRef, bounds] = useMeasure_1.default(containerRef, 0);
    if (!text || !middleEllipsis)
        return jsx_runtime_1.jsx("div", Object.assign({ className: classnames_1.default(classes.root, className) }, { children: text }), void 0);
    return (jsx_runtime_1.jsx("div", Object.assign({ className: classnames_1.default(classes.root, className), ref: measureRef, title: text }, { children: jsx_runtime_1.jsx(react_middle_ellipsis_1.default, Object.assign({ width: bounds.width }, { children: jsx_runtime_1.jsx("span", { children: text }, void 0) }), void 0) }), void 0));
};
exports.TextEllipsis = TextEllipsis;
exports.default = react_jss_1.default(textEllipsis_style_1.default)(react_1.memo(exports.TextEllipsis));
//# sourceMappingURL=index.js.map